import React from 'react';
import { MenuIcon } from 'lucide-react';
interface HeaderProps {
  toggleSidebar: () => void;
}
const Header = ({
  toggleSidebar
}: HeaderProps) => {
  return <header className="bg-white border-b border-secondary-200 h-16 flex items-center justify-between px-4 md:px-6" data-id="element-51">
      <div className="flex items-center" data-id="element-52">
        <button className="p-1 mr-3 rounded-md text-secondary-500 hover:bg-secondary-100 lg:hidden" onClick={toggleSidebar} data-id="element-53">
          <MenuIcon size={24} data-id="element-54" />
        </button>
        <h1 className="text-xl font-semibold text-secondary-900" data-id="element-55">
          E-Publication Module
        </h1>
      </div>
    </header>;
};
export default Header;